import RelationDataTable from './RelationDataTable'

export default RelationDataTable
